<script setup>
import GuestLayout from "@/Layouts/GuestLayout.vue";
import {InformationCircleIcon} from "@heroicons/vue/20/solid/index.js";

defineOptions({ layout: GuestLayout });
</script>

<template>
    <div class="bg-white px-6 py-32 lg:px-8">
        <div class="mx-auto max-w-3xl text-base/7 text-gray-700">
            <p class="text-base/7 font-semibold text-red-700">Introducing</p>
            <h1 class="mt-2 text-pretty text-4xl font-semibold tracking-tight text-gray-900 sm:text-5xl">Clinician Services</h1>
            <p class="mt-6 text-xl/8">The Band Instrument Repair Academy offers customizable Instrument Repair Clinician Services, tailored to meet the specific needs of music programs, schools, and organizations.</p>
            <div class="mt-8 max-w-2xl">
                <p class="mt-6">These services provide on-site repairs, maintenance clinics, and expert consultations, ensuring that instruments are properly maintained and repaired to keep music programs running smoothly.</p>
            </div>
            <figure class="mt-16 sm:pl-4">
                <img class="aspect-video sm:w-4/5 rounded-xl bg-gray-50 object-cover" src="../../../public/images/clarinetOnLogo@0.5x.jpg" alt="" />
<!--                <figcaption class="mt-4 flex gap-x-2 text-sm/6 text-gray-500">-->
<!--                    <InformationCircleIcon class="mt-0.5 size-5 flex-none text-gray-300" aria-hidden="true" />-->
<!--                    Faucibus commodo massa rhoncus, volutpat.-->
<!--                </figcaption>-->
            </figure>
            <div class="mt-16 max-w-2xl">
                <p class="mt-6">Designed to fit the unique demands of each client, these services offer flexibility and convenience, helping educators and musicians get the most out of their instruments with minimal disruption.</p>
                <p class="mt-6">Fill out our contact form for more information on our clinician services.</p>
            </div>
        </div>
    </div>
</template>

<style scoped>

</style>
